import React, { useState, useEffect, Fragment } from 'react';
import TextField from '@material-ui/core/TextField';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import FormGroup from '@material-ui/core/FormGroup';
import FormLabel from '@material-ui/core/FormLabel';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Loader from 'react-loader-spinner';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import blue from '@material-ui/core/colors/blue';
import pink from '@material-ui/core/colors/pink';

import axios from 'axios';
import apiUrl from '../../constants.js';

import Delete from '@material-ui/icons/Delete';

const theme = createMuiTheme({
  palette: {
    primary: blue,
    secondary: pink,
  },
  status: {
    danger: 'orange',
  },
});

const useStyles = makeStyles ( (theme) => ({
  padding4Divs: {
    padding: '15px 0px',
  },
  padding4Labels: {
    padding: '10px 0px',
  },
  margin4Divs: {
    marginTop: '10px'
  },
  spinnerDiv: {
    height: '400px',
    width: '400px',
    textAlign: 'center',
  },
  spinner: {
    marginTop: '150px'
  },
  table: {
    minWidth: 650,
  },
  imgPreview: {
    maxWidth: '100px',
    margin: 'auto'
  }
}));

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const LayerSlideSettings = () => {
  const classes = useStyles();

  const token = localStorage.getItem('token');
  const userId = localStorage.getItem('user_id');

  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");
  const [loading, setLoading] = useState(true);

  const [image, setImage] = useState({});
  const [images, setImages] = useState([]);

  useEffect(() => {
    getImages();
  }, []);

  const getImages = () => {

    let city_prefix = process.env.REACT_APP_CITY_PREFIX;
    let url = apiUrl+"v1/get-layerslide-images?id_user="+userId;

    if(typeof city_prefix !== "undefined"){
      url = url + "&city_prefix="+city_prefix;
    }

    axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setImages(response.data);
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      setLoading(false);
    });
  };

  const handleClose = (event, reason) => {
     if (reason === 'clickaway') {
       return;
     }
     setOpen(false);
  };

  const showAlert = (message, severity) => {
    setMessage(message);
    setSeverity(severity);
    setOpen(true);

    setTimeout(function(){
      setOpen(false);
    }, 3000);
  };

  const onChangeFileHandler = (e) => {
    setImage({ data: e.target.files[0] });
  }

  const handleSubmit = (e) => {
    e.preventDefault();

    setLoading(true);

    let data = new FormData();

    let url = apiUrl+"v1/upload-layerslide-image";
    let city_prefix = process.env.REACT_APP_CITY_PREFIX;

    if(typeof city_prefix !== "undefined"){
      data.append("city_prefix", city_prefix);
    }

    data.append("id_user", userId);
    data.append(
      "image",
      image.data,
      image.data.name
    );

    axios.post(url, data, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setImages(response.data);
      // showAlert("LOS DATOS HAN SIDO ACTUALIZADOS SATISFACTORIAMENTE", "success");
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      // showAlert("HA OCURRIDO UN ERROR AL INTENTAR ACTUALIZAR LOS DATOS, POR FAVOR INTENTE DE NUEVO MÁS TARDE", "error");
      setLoading(false);
    });
  };

  const removeImage = (id) => {
    setLoading(true);

    let url = apiUrl+"v1/delete-layerslide-image/"+id+"?id_user="+userId;

    axios.delete(url, {
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
          'Authorization': token,
        }
      }
    )
    .then(function (response) {
      console.log(response);
      setImages(response.data);
      showAlert("LOS DATOS HAN SIDO ACTUALIZADOS SATISFACTORIAMENTE", "success");
      setLoading(false);
    })
    .catch(function (error) {
      console.log(error);
      showAlert("HA OCURRIDO UN ERROR AL INTENTAR ACTUALIZAR LOS DATOS, POR FAVOR INTENTE DE NUEVO MÁS TARDE", "error");
      setLoading(false);
    });

  };

  return (
    <Grid container spacing={1}>

      <Snackbar open={open} autoHideDuration={6000} onClose={handleClose}>
        <Alert onClose={handleClose} severity={severity}>
          {message}
        </Alert>
      </Snackbar>

      <Grid item xs={12} sm={12}>
       <Typography variant="h4">Opciones de LayerSlide y/o Banner principal</Typography>
      </Grid>

      { loading ?
        <Grid item xs={12} sm={12} className={classes.spinnerDiv}>
          <Loader
            type="Oval"
            color="#00BFFF"
            height={50}
            width={50}
            className={classes.spinner}
          />
        </Grid>
        :
          <Fragment>
            <Grid item xs={12} sm={6}>
              <form onSubmit={(e) => handleSubmit(e)}>
                  <FormGroup component="fieldset">
                    <FormLabel component="legend">Cargar imagen</FormLabel>
                    <input
                       type="file"
                       name="image"
                       required
                       className={classes.padding4Labels}
                       onChange={(e) => onChangeFileHandler(e)}
                       />
                  </FormGroup>

                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className={classes.margin4Divs}
                  >
                    Cargar
                  </Button>
              </form>
            </Grid>

            <Grid item xs={12} sm={6}>

              <table className="table marginUp">
                <thead>
                  <tr>
                    <th>Imagen</th>
                    <th>Opciones</th>
                  </tr>
                </thead>

                <tbody>

                {
                  images.length>0 ?
                    images.map((image, index) => (

                      <tr key={index}>
                        <td>
                          <div className="previewBox">
                            <a href={image.url} target="_blank">
                              <img
                                src={image.url}
                                className={classes.imgPreview}
                                />
                            </a>
                          </div>
                        </td>
                        <td>
                        <Button
                          type="submit"
                          variant="contained"
                          color="secondary"
                          value={image.id}
                          className={classes.margin4Divs}
                          onClick={() => removeImage(image.id)}
                        >
                          <Delete/> Eliminar
                        </Button>
                        </td>
                      </tr>

                     ))
                   :
                   <tr>
                     <td colspan="2">
                      No hay imagenes cargadas
                     </td>
                   </tr>
                }




                </tbody>
              </table>

            </Grid>

          </Fragment>
      }

   </Grid>
  )
};

export default LayerSlideSettings;
